import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, from, switchMap, throwError } from 'rxjs';
import { AdminSessionService } from './admin-session.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(private sessions: AdminSessionService) {}
  // Intercepts HTTP requests, adds Authorization and App-Version headers
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authToken: string | null = null;

    // App version from environment
    const appVersion = environment.appVersion;

    if (request.url.includes('https://api.postalpincode.in/pincode/')) {
      // Do not modify the request, just forward it as-is
      return next.handle(request);
    }

    // Get token from localStorage if in browser
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      authToken = localStorage.getItem('token');
    }

    // Clone and add headers
    const headers: { [header: string]: string } = {
      'App-Version': appVersion,
    };

    if (!request.url.startsWith(environment.baseUrl + 'api/') && !request.url.startsWith(environment.baseUrl + 'queryHub') && !request.url.startsWith(environment.baseUrl + 'leadNotificationHub')) return next.handle(request);

    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }

    const clonedRequest = request.clone({ setHeaders: headers, withCredentials: request.url.endsWith("api/Auth/Login") || request.withCredentials });

    return next.handle(clonedRequest).pipe(catchError((error: HttpErrorResponse) => {
      let renewable = false;
      try { renewable = !!JSON.parse(atob((authToken ?? '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).admin_sid; } catch {}
      if (error.status !== 401 || !authToken || !renewable || request.url.includes('/Auth/')) return throwError(() => error);
      return from(this.sessions.renew(authToken)).pipe(switchMap(token => next.handle(clonedRequest.clone({ setHeaders: { Authorization: 'Bearer ' + token } }))));
    }));
  }
}
